import { JsonObject } from 'json2typescript';
import { ClientDataOnboardingInterface } from '../interfaces/client-data-onboarding.interface';

@JsonObject('ClientDataOnboarding')
export class ClientDataOnboarding implements ClientDataOnboardingInterface {
  AcceptEmailMarketing?: boolean;
  AcceptMarketing?: boolean;
  BirthDate?: string;
  DisclaimerOnboardingChecked?: boolean;
  DocExpirationDate?: string;
  DocExpirationDatePermanent?: boolean;
  DocId?: string;
  DocType?: string;
  Email?: string;
  ExpirationDateLegalEntityId: string;
  IsForeigner?: boolean;
  IsResident?: boolean;
  Language?: string;
  LegalGuardian_contract_relation?: string;
  LegalGuardians?: any[];
  MainShareHoldersData: { ShareHolders: any[] };
  Name?: string;
  Nature?: string;
  Password?: any;
  Phone?: string;
  ServiceModelCode?: string;
  Surname?: string;
  Type?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
